/**
 * App Root Component
 * CCH Care - Version 1.0
 *
 * Updated 2026-05-30 — Mount ShiftProvider inside AuthProvider so the
 * shift state (primary, outgoing, isOutgoingMode) is shared across
 * the AppShell chip, ShiftDashboard, ADLFlowSheetPage, and any other
 * consumer. Previously each component's useShift() created its own
 * isolated useState instance, which is why entering outgoing mode in
 * the AppShell chip didn't propagate to the flow sheet's shift binding
 * — the flow sheet's local isOutgoingMode never flipped.
 */

import { CheckinProvider } from './hooks/useCheckin';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './features/auth/useAuth';
import { ShiftProvider } from './hooks/useShift';
import CareRouter from './components/routing/CareRouter';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ShiftProvider>
          <CheckinProvider>
            <CareRouter />
          </CheckinProvider>
        </ShiftProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}